import Vue from 'vue';
import router from './router';
import App from './App';
import Vuex from 'vuex';
import store from './vuex/store';
import axios from 'axios';
import VueResouse from 'vue-resource';
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import { Button } from 'vant';
import { RadioGroup, Radio } from 'vant';

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Vuex);
Vue.use(VueResouse);
Vue.use(ElementUI)
import { List } from 'vant';

Vue.use(List);

// Vue.use($);

axios.defaults.withCredentials = true;

// 添加请求拦截器
/*axios.interceptors.request.use(function (config) {
     // 在发送请求之前做某事
  // let token = localStorage.getItem('token');
  let token = localStorage.getItem('token');
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
},
  function (error) {
     // 请求错误时做些事
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(response => {
  // console.log(response);
  return response;
},error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        alert('登录超时，请重新登录！')
        localStorage.setItem('user', '{}');
        localStorage.setItem('token', null);
        // this.$store.commit('newUser', {});
        router.replace({
          path: '/',
          query: {redirect: router.currentRoute.fullPath}
        });
    }
  }
  return Promise.reject(error.response.data);   // 返回接口返回的错误信息
});*/
Vue.prototype.$ajax = axios;
Vue.prototype.hrefUrl = window.location.href.split('#')[0];
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});




// WEBPACK FOOTER //
// ./src/main.js